import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useAuth } from '../../contexts/AuthContext';

// Rôles "bureau" — identique à Membre.prototype.estAdmin() côté backend et à
// isAdmin() dans AuthContext. Gardé synchronisé à la main aux deux endroits
// (pas de source unique côté frontend actuellement).
const ROLES_BUREAU = ['administrateur', 'president', 'tresorier', 'tresorier_adjoint', 'secretaire_general', 'secretaire_general_adjoint', 'commissaire'];

const ProtectedRoute = ({ allowedRoles = null, blockOfficers = false, children }) => {
  const { user, loading } = useAuth();

  // Afficher un loader pendant la vérification
  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
        bgcolor="background.default"
      >
        <CircularProgress size={60} />
      </Box>
    );
  }

  // Rediriger vers la page de connexion si non authentifié
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Vérifier les rôles autorisés
  if (allowedRoles && !allowedRoles.includes(user.role)) {
    // Rediriger vers le dashboard approprié selon le rôle
    if (ROLES_BUREAU.includes(user.role)) {
      return <Navigate to="/admin/dashboard" replace />;
    } else {
      return <Navigate to="/member/dashboard" replace />;
    }
  }

  // ── Espace membre : un officier (bureau) qui atterrit ici (lien direct,
  // favori navigateur, bouton précédent...) est renvoyé vers l'admin, plutôt
  // que de simplement laisser passer faute de allowedRoles déclaré sur cette
  // route — c'est ce qui faisait voir le menu membre à la secrétaire générale
  // dès qu'elle arrivait sur /member/... autrement que via le formulaire de
  // connexion (qui, lui, redirige correctement).
  if (blockOfficers && ROLES_BUREAU.includes(user.role)) {
    return <Navigate to="/admin/dashboard" replace />;
  }

  // Si children est fourni, le rendre, sinon rendre Outlet pour les routes imbriquées
  return children ? children : <Outlet />;
};

export default ProtectedRoute;
